import React from "react";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import ROUTES from "./config/routes";
import THEME from "./config/theme";
import STORE from "./store";
import { i18n } from "./config/i18n";

const App = () => {
  return (
    <Provider store={STORE}>
      <ThemeProvider theme={THEME}>
        <CssBaseline />
        <I18nextProvider i18n={i18n}>
          <RouterProvider router={ROUTES} />
        </I18nextProvider>
      </ThemeProvider>
    </Provider>
  );
};
export default App;
